var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"myGranja"},[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('myGranja.title')))]),_c('v-card-text',[(_vm.hasFeature('chores'))?_c('ChoresChecklist'):_vm._e(),(_vm.hasFeature('tasks'))?_c('PersonalTasks'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }